import FeedbackError from '../../components/atoms/feedbacks/feedback-error'

export default {
  components: { FeedbackError },
  data() {
    return {
      showableErrorFeedback: false,
      errorMessage: '送信できませんでした',
      lastName: '',
      isLastNameFocused: false,
      firstName: '',
      isFirstNameFocused: false,
      lastNameKana: '',
      isLastNameKanaFocused: false,
      firstNameKana: '',
      isFirstNameKanaFocused: false,
      contactType: '',
      email: '',
      isEmailFocused: false,
      emailConfirmation: '',
      isEmailConfirmationFocused: false,
      detail: '',
      isDetailFocused: false,
      isAgreedPrivacyPolicy: false
    }
  },
  created() {
    this.lastName = document.querySelector(`[v-model='lastName']`).value
    this.firstName = document.querySelector(`[v-model='firstName']`).value
    this.lastNameKana = document.querySelector(`[v-model='lastNameKana']`).value
    this.firstNameKana = document.querySelector(`
      [v-model='firstNameKana']`).value
    this.contactType = document.querySelector(`[v-model='contactType']`).value
    this.email = document.querySelector(`[v-model='email']`).value
    this.emailConfirmation = document.querySelector(`
      [v-model='emailConfirmation']`).value
    this.detail = document.querySelector(`[v-model='detail']`).value
  },
  mounted() {
    // フィードバックを表示しない場合はslim側で制御がかかっているので、jsでは常にフィードバックを表示するような形にしている。
    // 最初からshowableErrorFeedbackをtrueにするとenterが発火しないので、ここで変更する
    this.showErrorFeedback()
  },
  computed: {
    isContactTypeSelected() {
      return this.contactType !== ''
    },
    isLastNameInputted() {
      return this.lastName.length !== 0
    },
    isFirstNameInputted() {
      return this.firstName.length !== 0
    },
    isLastNameKanaInputted() {
      return this.lastNameKana.length !== 0
    },
    isFirstNameKanaInputted() {
      return this.firstNameKana.length !== 0
    },
    isEmailInputted() {
      return this.email.length !== 0
    },
    isEmailConfirmationInputted() {
      return this.emailConfirmation.length !== 0
    },
    isDetailInputted() {
      return this.detail.length !== 0
    },
    isSubmitButtonAvailable() {
      return (
        this.isContactTypeSelected &&
        this.isLastNameInputted &&
        this.isFirstNameInputted &&
        this.isLastNameKanaInputted &&
        this.isFirstNameKanaInputted &&
        this.isEmailInputted &&
        this.isEmailConfirmationInputted &&
        this.isDetailInputted &&
        this.isAgreedPrivacyPolicy
      )
    },
    isSubmitButtonDisabled() {
      return !this.isSubmitButtonAvailable
    }
  },
  methods: {
    // Error Feedback
    showErrorFeedback() {
      this.showableErrorFeedback = true
    },
    enterError() {
      setTimeout(() => {
        this.showableErrorFeedback = false
      }, 3000)
    },
    // Focus
    onFocusLastName() {
      this.isLastNameFocused = true
    },
    onFocusFirstName() {
      this.isFirstNameFocused = true
    },
    onFocusLastNameKana() {
      this.isLastNameKanaFocused = true
    },
    onFocusFirstNameKana() {
      this.isFirstNameKanaFocused = true
    },
    onFocusEmail() {
      this.isEmailFocused = true
    },
    onFocusEmailConfirmation() {
      this.isEmailConfirmationFocused = true
    },
    onFocusDetail() {
      this.isDetailFocused = true
    },
    // Blur
    onBlurLastName() {
      this.isLastNameFocused = false
    },
    onBlurFirstName() {
      this.isFirstNameFocused = false
    },
    onBlurLastNameKana() {
      this.isLastNameKanaFocused = false
    },
    onBlurFirstNameKana() {
      this.isFirstNameKanaFocused = false
    },
    onBlurEmail() {
      this.isEmailFocused = false
    },
    onBlurEmailConfirmation() {
      this.isEmailConfirmationFocused = false
    },
    onBlurDetail() {
      this.isDetailFocused = false
    },
    // checkbox
    onAgreedPrivacyPolicyChecked() {
      this.isAgreedPrivacyPolicy = !this.isAgreedPrivacyPolicy
    },
    onClickPrivacyPolicyLink() {
      event.stopPropagation()
    }
  }
}
